import {clsx} from 'external/clsx'
import {FC, Link, useMemo} from 'external/react'

import usePublic from 'context/public-context/hook'

type SubjectProps = {
    selected: boolean,
    idSubject: string,
    languageId: string,
    color: string,
    name: string,
    courses: number
}

const Subject: FC<SubjectProps> = props => {
    const {selected, idSubject, name, courses, color, languageId} = props
    const {navigation} = usePublic()

    const linkToCourses = useMemo(() => navigation.offerSubjects.active && navigation.offerCourses.linkWithQuery({languageId}, true, {idSubject}), [navigation, idSubject])

    return (
        <Link to={linkToCourses} className={clsx({disabled__subject: selected})} style={{textDecoration: 'none'}}>
            <div color={color} className={clsx('bodyListItem', {disabled__subject_color: selected})}>
                <h4>{name}</h4>
                <p>{courses} Cursos</p>
            </div>

        </Link>
    )
}

export {Subject as default}